<template>
    <div class="analysis-graphs-container left">
        <fan-graphs/>
        <div class="navi-btn">
            <router-link to="/" tag="button" class="back-btn"><span>{{translate("back_btn")}}</span></router-link>
        </div>
    </div>
</template>

<script>
    import FanGraphs from "../configuration_steps/fourthStep/FanGraphs";

    export default {
        name: "AnalysisGraphs",
        components: {FanGraphs},
        data() {
            return {}
        },

        methods: {
            translate(code) {
                let arg = {
                    type: 'translate',
                    code: code,
                    out: ""
                }

                this.$store.commit(arg);

                return arg.out;
            },
        },
        computed: {
            getDetailedGraphs() {
                return this.$store.state.detailedGraphs;
            }
        },
    }
</script>

<style scoped>

</style>